var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 10,
  viewBox: "0 0 8 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 6 4.679 9.655a.897.897 0 0 1-1.358 0L0 6v-.508C0 4.944.442 4.5.992 4.5H1.5L3 6.634V0h2v6.634L6.5 4.5h.508c.548 0 .992.442.992.993z"
})));
export default SvgArrowS;